import { Roles } from '@prisma/client';
import { getIn } from 'formik';

// Checkout nests these values under `customer`, the composer keeps them at the
// root — both the classic and redesigned client sections resolve paths here.
export const getInputName = (prefix: string[], name: string) =>
  `${prefix.join('.')}${prefix.length ? '.' : ''}${name}`;

export const getValue = (values: any, prefix: string[], name: string) =>
  getIn(values, getInputName(prefix, name));

// Shared by the classic hit row and the redesigned result row so picking a
// client stages exactly the same values in both.
export const applyHitToForm = (
  hit: any,
  namePrefix: string[],
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => any,
) => {
  // Algolia can hand this back as a number, or omit it entirely.
  const phoneString = hit.phoneNumber ? `${hit.phoneNumber}` : '';

  setFieldValue(getInputName(namePrefix, 'firstName'), hit.firstName);
  setFieldValue(getInputName(namePrefix, 'lastName'), hit.lastName);
  setFieldValue(getInputName(namePrefix, 'email'), hit.email);
  setFieldValue(getInputName(namePrefix, 'phoneNumber'), phoneString);
  setFieldValue(getInputName(namePrefix, 'customerId'), hit.customerId);
};

export interface ClientSearchAutofillValues {
  name: string;
  firstName: string;
  lastName: string;
  customerId: string;
  customerGuestId?: string;
  phoneNumber: string;
  dob: string | undefined;
  email: string;
  role?: Roles;
}
